import React from "react";
import { DragDropContext } from "react-beautiful-dnd";
import PropTypes from "prop-types";

import { Placeholder } from "semantic-ui-react";

import { createDroppable, DraggableFragment } from "components/DragDrop";
import Task from "components/Task";

// eslint-disable-next-line max-len
import { TaskConditionsGroupView } from "scenes/Hubly/components/Workspace/components/WorkflowContainer/components/WorkflowEditor/components/TasksEditor/components";

import { useClientCardTasks } from "./hooks";
import { ScrollToTaskWrapper, SimpleTaskView } from "./components";

const DroppableTaskList = createDroppable("TaskList");

export function TaskList({
  clientWorkflow,
  client,
  newCommentRef,
  comments,
  showAssignAdvisor,
}) {
  const { tasksGroup, handleOnTaskReorder, loading } = useClientCardTasks(
    clientWorkflow.id
  );

  if (loading)
    return (
      <Placeholder style={{ margin: "1em 1.5em" }}>
        <Placeholder.Line length="full" />
        <Placeholder.Line length="full" />
        <Placeholder.Line length="full" />
      </Placeholder>
    );

  if (!tasksGroup || tasksGroup?.length === 0) {
    return (
      <span style={{ color: "grey", display: "flex", margin: "1em 0" }}>
        This workflow contains no tasks
      </span>
    );
  }

  return (
    <DragDropContext onDragEnd={handleOnTaskReorder}>
      <DroppableTaskList id="dnd-client-workflow-task">
        <ScrollToTaskWrapper workflowId={clientWorkflow?.id}>
          {tasksGroup.map((tg, i) => {
            return {
              taskId: tg.id,
              renderComponent: tg?.conditions ? (
                <div>
                  <DraggableFragment
                    id={`${client?.id}_${tg?.id}`}
                    key={`${client?.id}_${tg?.id}`}
                    index={i}
                    disabled
                  >
                    <div style={{ marginBottom: ".5em" }}>
                      <TaskConditionsGroupView
                        key={tg?.id}
                        taskGroup={tg}
                        workflowId={clientWorkflow?.id}
                        withDraggable
                        disabled
                      >
                        {(taskList) => {
                          return taskList.map((task) => {
                            return (
                              <SimpleTaskView
                                key={`${client?.id}_${task?.id}`}
                                title={task.title}
                                currentAssignee={task.assignee}
                                showAssignAdvisor={showAssignAdvisor}
                              />
                            );
                          });
                        }}
                      </TaskConditionsGroupView>
                    </div>
                  </DraggableFragment>
                </div>
              ) : (
                <Task
                  task={tg}
                  taskIndex={i}
                  client={client}
                  clientWorkflow={clientWorkflow}
                  comments={comments}
                  key={`${client?.id}_${tg?.id}`}
                  newCommentRef={newCommentRef}
                />
              ),
            };
          })}
        </ScrollToTaskWrapper>
      </DroppableTaskList>
    </DragDropContext>
  );
}

TaskList.propTypes = {
  clientWorkflow: PropTypes.object.isRequired,
  client: PropTypes.object.isRequired,
  newCommentRef: PropTypes.node.isRequired,
  comments: PropTypes.array,
  showAssignAdvisor: PropTypes.bool,
};

TaskList.defaultProps = {
  comments: [],
  showAssignAdvisor: false,
};

export default TaskList;
